import React from "react";
import PropTypes from "prop-types";
import { ProgressBar } from "@opendate-app/setlist";
import "./classesShared.css";

const LEVEL_TONES = { inactive: "muted", full: "error", nearly_full: "warning", open: "brand" };

export default function ClassCapacityMeter({ taken = 0, capacity, percent = 0, level, status }) {
  const canceled = status === "canceled";
  const readout = `${canceled ? "—" : taken} / ${capacity ?? "—"}`;
  return (
    <ProgressBar
      className="classes-capacity-meter"
      value={canceled ? 0 : percent}
      tone={LEVEL_TONES[level] || "brand"}
      label="right"
      format={() => readout}
      aria-label={canceled ? "Class canceled" : `${taken} of ${capacity ?? "unlimited"} spots taken`}
    />
  );
}

ClassCapacityMeter.propTypes = {
  taken: PropTypes.number,
  capacity: PropTypes.number,
  percent: PropTypes.number,
  level: PropTypes.oneOf(Object.keys(LEVEL_TONES)),
  status: PropTypes.string,
};
